import { useTranslation } from 'react-i18next'
import { Button, Dialog, DialogActions, DialogContent, DialogContentText } from '@mui/material'
import type { CountryCode } from '~/model'

type Props = {
  countryCode: CountryCode
  postalCode: string
  onClose: () => void
}

export const Alert = ({ countryCode, postalCode, onClose }: Props) => {
  const { t } = useTranslation()

  return (
    // eslint-disable-next-line react/jsx-boolean-value
    <Dialog open={true} onClose={onClose}>
      <DialogContent>
        <DialogContentText>
          {t('noTimeWindowFound', { postalCode, country: t(`country.${countryCode}`) })}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          {t('ok')}
        </Button>
      </DialogActions>
    </Dialog>
  )
}
